
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3cba"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3cba"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gYMat", function(module, exports) {

$parcel$export(module.exports, "register", () => $c5c79d140c56a49c$export$6503ec6e8aabbaf, (v) => $c5c79d140c56a49c$export$6503ec6e8aabbaf = v);
var $c5c79d140c56a49c$export$6503ec6e8aabbaf;
var $c5c79d140c56a49c$export$f7ad0328861e2f03;
"use strict";
var $c5c79d140c56a49c$var$mapping = new Map();
function $c5c79d140c56a49c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c5c79d140c56a49c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c5c79d140c56a49c$var$resolve(id) {
    var resolved = $c5c79d140c56a49c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c5c79d140c56a49c$export$6503ec6e8aabbaf = $c5c79d140c56a49c$var$register;
$c5c79d140c56a49c$export$f7ad0328861e2f03 = $c5c79d140c56a49c$var$resolve;

});

var $4e47031de85deecd$exports = {};

(parcelRequire("gYMat")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.57fab002.js","hfd23","icons.c14567a0.svg"]'));

const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ba30e20475feac5a$export$fa405bbf47d510e2 = 5;
const $ba30e20475feac5a$export$2ad63e91d9f081e6 = 10;
const $ba30e20475feac5a$export$a9861bd62f48e142 = "73e71935-79e4-41b7-aa4a-2de4defe2cb3";


const $d3824bf2ef2465db$export$83e74882c5df8fe1 = function(sec) {
    return new Promise((_, reject)=>{
        setTimeout(()=>{
            reject("Timeout, request took too long.");
        }, sec * 1000);
    });
};
const $d3824bf2ef2465db$export$5c069c93d2b7493f = function(sec) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve("Timeout, request took too long.");
        }, sec * 1000);
    });
};
const $d3824bf2ef2465db$export$2b3ff41fecbef7c8 = async function(url, jsonData = "") {
    try {
        const fetchPromise = jsonData !== "" ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(jsonData)
        }) : fetch(url);
        const response = await Promise.race([
            fetchPromise,
            $d3824bf2ef2465db$export$83e74882c5df8fe1((0, $ba30e20475feac5a$export$fa405bbf47d510e2))
        ]);
        if (!response.ok) throw new Error("Couldn't fetch data.");
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};




const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        recipes: [],
        numberOfPages: 0,
        pageNumber: 1,
        recipesPerPage: (0, $ba30e20475feac5a$export$2ad63e91d9f081e6)
    },
    bookmarks: []
};
function $0f1d4402dffacf5b$var$formatAndStateRecipe(recipe) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = {
        _id: recipe.id,
        title: recipe.title,
        cookingTime: recipe.cooking_time,
        imageUrl: recipe.image_url,
        ingredients: recipe.ingredients,
        publisher: recipe.publisher,
        servings: recipe.servings,
        sourceUrl: recipe.source_url,
        bookmarked: false,
        ...recipe.key && {
            key: recipe.key
        }
    };
}
const $0f1d4402dffacf5b$export$a30a1473507660db = async function(id) {
    try {
        const { data: { recipe: recipe } = "" } = await (0, $d3824bf2ef2465db$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${id}?key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        if (!recipe) throw new Error("Recipe not found");
        $0f1d4402dffacf5b$var$formatAndStateRecipe(recipe);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark._id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe._id);
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$8d57c561ecf3eee5 = async function(query) {
    try {
        const { data: { recipes: recipes } = "" } = await (0, $d3824bf2ef2465db$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        if (recipes.length === 0) throw new Error("No Recipes Found With This Category.");
        const mappedRecipes = recipes.map((recipe)=>{
            return {
                _id: recipe.id,
                title: recipe.title,
                imageUrl: recipe.image_url,
                publisher: recipe.publisher,
                ...recipe.key && {
                    key: recipe.key
                }
            };
        });
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.recipes = [
            ...mappedRecipes
        ];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.numberOfPages = Math.ceil(recipes.length / $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.recipesPerPage);
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$2d05d93cb3b7f780 = function(page = 1) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.pageNumber = page;
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.recipesPerPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.recipesPerPage;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.recipes.slice(start, end);
};
const $0f1d4402dffacf5b$export$72a4c7e3635cff29 = function(servingsNumber) {
    const servingsRatio = servingsNumber / $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings;
    //side effects change in state
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.ingredients.forEach((ingredient)=>{
        ingredient.quantity = ((ingredient.quantity || 1) * servingsRatio).toFixed(2); //nulls =>1     2decimal
    });
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings = servingsNumber;
};
const $0f1d4402dffacf5b$export$72009cc673d27d80 = function(recipe) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(recipe);
    localStorage.setItem("bookmarks", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
const $0f1d4402dffacf5b$export$136048bcb9946c75 = function(recipeId) {
    const filteredBookmarks = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.filter((bookmark)=>bookmark._id !== recipeId);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = [
        ...filteredBookmarks
    ];
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
    localStorage.setItem("bookmarks", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
const $0f1d4402dffacf5b$export$fd68aeccd5e8e1ce = function() {
    const bookmarks = JSON.parse(localStorage.getItem("bookmarks")) || [];
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = bookmarks;
};
const $0f1d4402dffacf5b$export$d660c2254e74960d = async function(addedRecipe) {
    const formattedUploadRecipe = {
        title: addedRecipe.title,
        cooking_time: addedRecipe.cookingTime,
        image_url: addedRecipe.image,
        ingredients: addedRecipe.ingredients,
        publisher: addedRecipe.publisher,
        servings: addedRecipe.servings,
        source_url: addedRecipe.sourceUrl
    };
    const { data: { recipe: recipe } } = await (0, $d3824bf2ef2465db$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`, formattedUploadRecipe);
    $0f1d4402dffacf5b$var$formatAndStateRecipe(recipe);
    $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
};


var $37426a2cd19eef49$exports = {};
$37426a2cd19eef49$exports = new URL("icons.c14567a0.svg", import.meta.url).toString();



class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    #parentElement;
    #data;
    #errorMessage;
    #successMessage;
    constructor(parentElement, errorMessage = "", successMessage = ""){
        this.#parentElement = parentElement;
        this.#errorMessage = errorMessage;
        this.#successMessage = successMessage;
    }
    set data(data) {
        this.#data = data;
    }
    get data() {
        return this.#data;
    }
    get parentElement() {
        return this.#parentElement;
    }
    get errorMessage() {
        return this.#errorMessage;
    }
    get successMessage() {
        return this.#successMessage;
    }
    render(data) {
        if (Array.isArray(data) && data.length === 0) return this.renderErrorMessage();
        this.data = data;
        this.clear();
        const markup = this._generateMarkup();
        this.parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(newData) {
        const currentNodesArray = Array.from(this.parentElement.querySelectorAll("*"));
        this.data = newData;
        const newMarkup = this._generateMarkup();
        const newNodesArray = Array.from(document.createRange().createContextualFragment(newMarkup).querySelectorAll("*"));
        newNodesArray.forEach((newNode, i)=>{
            const currentNode = currentNodesArray[i];
            if (!newNode.isEqualNode(currentNode) && newNode.firstChild?.nodeValue.trim() !== "" //trim**
            ) currentNode.textContent = newNode.textContent;
            if (!newNode.isEqualNode(currentNode)) {
                const newNodesAttributesArray = Array.from(newNode.attributes);
                newNodesAttributesArray.forEach((attribute)=>{
                    currentNode.setAttribute(attribute.name, attribute.value);
                });
            }
        });
    }
    renderErrorMessage(errorMessage = this.errorMessage) {
        const markup = `<div class="error">
    <div>
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports)))}#icon-alert-triangle"></use>
      </svg>
    </div>
    <p>${errorMessage}</p>
  </div>`;
        this.clear();
        this.parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderSuccessMessage(successMessage = this.successMessage) {
        const markup = `<div class="error">
    <div  class="message">
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports)))}#icon-smile"></use>
      </svg>
    </div>
    <p>${successMessage}</p>
  </div>`;
        this.clear();
        this.parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderSpinner() {
        const markup = `<div class="spinner">
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports)))}#icon-loader"></use>
    </svg>
  </div>`;
        this.clear();
        this.parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    clear() {
        this.parentElement.innerHTML = "";
    }
}


class $e5dc5dc5ede8bdf4$var$AddRecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    #btnAddRecipe = document.querySelector(".nav__btn--add-recipe");
    #btnCloseModal = document.querySelector(".btn--close-modal");
    #overlay = document.querySelector(".overlay");
    #window = document.querySelector(".add-recipe-window");
    constructor(parentElement){
        super(parentElement);
        this.#addAddRecipeHandler();
        this.#addCloseModalHandler();
    }
    #toggleOverlay() {
        this.#overlay.classList.toggle("hidden");
        this.#window.classList.toggle("hidden");
    }
    #addAddRecipeHandler() {
        this.#btnAddRecipe.addEventListener("click", this.#toggleOverlay.bind(this));
    }
    #addCloseModalHandler() {
        this.#btnCloseModal.addEventListener("click", this.#toggleOverlay.bind(this));
    }
    addUploadRecipeHandler(handler) {
        this.parentElement.addEventListener("click", function(e) {
            e.preventDefault();
            const btn = e.target.closest(".upload__btn");
            if (!btn) return;
            //this =>event listener=> element = > this.parentElement
            const formData = new FormData(this);
            handler(...formData);
        });
    }
    closeModal() {
        if (this.#overlay.classList.contains("hidden")) return;
        this.#toggleOverlay();
    }
    _generateMarkup() {
        return ` <div class="upload__column">
    <h3 class="upload__heading">Recipe data</h3>
    <label>Title</label>
    <input value="TESTTTT" required name="title" type="text" />
    <label>URL</label>
    <input value="TESTTTT" required name="sourceUrl" type="text" />
    <label>Image URL</label>
    <input value="TESTTTT" required name="image" type="text" />
    <label>Publisher</label>
    <input value="TESTTTT" required name="publisher" type="text" />
    <label>Prep time</label>
    <input value="23" required name="cookingTime" type="number" />
    <label>Servings</label>
    <input value="23" required name="servings" type="number" />
  </div>

  <div class="upload__column">
    <h3 class="upload__heading">Ingredients</h3>
    <label>Ingredient 1</label>
    <input
      value="0.5,kg,Rice"
      type="text"
      required
      name="ingredient-1"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
    <label>Ingredient 2</label>
    <input
      value="1,,Avocado"
      type="text"
      name="ingredient-2"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
    <label>Ingredient 3</label>
    <input
      value=",,salt"
      type="text"
      name="ingredient-3"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
    <label>Ingredient 4</label>
    <input
      type="text"
      name="ingredient-4"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
    <label>Ingredient 5</label>
    <input
      type="text"
      name="ingredient-5"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
    <label>Ingredient 6</label>
    <input
      type="text"
      name="ingredient-6"
      placeholder="Format: 'Quantity,Unit,Description'"
    />
  </div>

  <button class="btn upload__btn">
    <svg>
      <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}.svg#icon-upload-cloud"></use>
    </svg>
    <span>Upload</span>
  </button>`;
    }
}
var $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039 = new $e5dc5dc5ede8bdf4$var$AddRecipeView(document.querySelector(".upload"));




class $bc12b31dab7d742c$export$2e2bcd8739ae039 extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    constructor(parentElement, errorMessage, successMessage){
        super(parentElement, errorMessage, successMessage);
    }
    _generateMarkup() {
        return this.data.map(this.#generatePreviewMarkup).join(" ");
    }
    #generatePreviewMarkup(recipe) {
        return `<li class="preview">
    <a class="preview__link  ${window.location.hash.slice(1) === recipe._id && "preview__link--active"}" href=#${recipe._id}>
      <figure class="preview__fig">
        <img src=${recipe.imageUrl} alt=${recipe.title} />
      </figure>
      <div class="preview__data">
        <h4 class="preview__title">${recipe.title}</h4>
        <p class="preview__publisher">${recipe.publisher}</p>
        <div class="preview__user-generated">
        <svg>
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#${recipe.key && "icon-user"}"></use>
      </svg>
        </div>
      </div>
    </a>
    </li>
  `;
    }
}


class $5d1bb7e064b2cbd1$var$BookmarksView extends (0, $bc12b31dab7d742c$export$2e2bcd8739ae039) {
    constructor(parentElement, errorMessage, successMessage){
        super(parentElement, errorMessage, successMessage);
    }
}
var $5d1bb7e064b2cbd1$export$2e2bcd8739ae039 = new $5d1bb7e064b2cbd1$var$BookmarksView(document.querySelector(".bookmarks__list"), "No bookmarks yet. Find a nice recipe and bookmark it \uD83C\uDF74\uD83D\uDE48", "bookmarks Found \uD83D\uDE0B");




class $cfa940594ee109f7$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    constructor(parentElement){
        super(parentElement);
    }
    addpaginationhandler(handler) {
        this.parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".pagination__btn");
            if (!btn) return;
            const updateTo = +btn.dataset.updateTo;
            handler(updateTo);
        });
    }
    #generateNextButton() {
        return ` <button class="btn--inline pagination__btn pagination__btn--next" data-update-to="${this.data.search.pageNumber + 1}">
    <span>Page ${this.data.search.pageNumber + 1}</span>
    <svg class="search__icon">
      <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}.svg#icon-arrow-right"></use>
    </svg>
  </button>`;
    }
    #generatePrevButton() {
        return `<button class="btn--inline pagination__btn pagination__btn--prev" data-update-to="${this.data.search.pageNumber - 1}">
  <svg class="search__icon">
    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}.svg#icon-arrow-left"></use>
  </svg>
  <span>Page ${this.data.search.pageNumber - 1}</span>
</button>`;
    }
    _generateMarkup() {
        const totalPages = this.data.search.numberOfPages;
        const page = this.data.search.pageNumber;
        if (page == 1 && totalPages > 1) return this.#generateNextButton();
        if (page == totalPages && page !== 1) return this.#generatePrevButton();
        if (page > 1 && page < totalPages) return `${this.#generatePrevButton()}${this.#generateNextButton()}`;
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView(document.querySelector(".pagination"));




class $d14dc0f178617192$var$RecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    constructor(parentElement, errorMessage, successMessage){
        super(parentElement, errorMessage, successMessage);
    }
    //Events
    addRenderHandler(handler) {
        [
            "hashchange",
            "load"
        ].forEach((e)=>window.addEventListener(e, handler));
    }
    addServingsHandler(handler) {
        this.parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            const updateTo = +btn.dataset.updateTo;
            if (updateTo > 0) handler(updateTo);
        });
    }
    addBookmarkHandler(handler) {
        this.parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    //API
    // _ not # inheritance private enclosing class
    _generateMarkup() {
        return `  <figure class="recipe__fig">
    <img src="${this.data.imageUrl}" alt="Tomato" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this.data.title}</span>
    </h1>
  </figure>

  <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${this.data.cookingTime}</span>
      <span class="recipe__info-text">minutes</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${this.data.servings}</span>
      <span class="recipe__info-text">servings</span>

      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--update-servings" data-update-to="${this.data.servings - 1}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--update-servings" data-update-to="${this.data.servings + 1}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>

    <div class="recipe__user-generated">
    <svg>
    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#${this.data.key && "icon-user"}"></use>
  </svg>
      
    </div>
    <button class="btn--round btn--bookmark">
      <svg class="">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-bookmark${this.data.bookmarked === true ? "-fill" : ""}"></use>
      </svg>
    </button>
  </div>

  <div class="recipe__ingredients">
    <h2 class="heading--2">Recipe ingredients</h2>
    <ul class="recipe__ingredient-list">
     ${this.#generateIngredientsMarkup()}

    </ul>
  </div>

  <div class="recipe__directions">
    <h2 class="heading--2">How to cook it</h2>
    <p class="recipe__directions-text">
      This recipe was carefully designed and tested by
      <span class="recipe__publisher">${this.data.publisher}</span>. Please check out
      directions at their website.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this.data.sourceUrl}"
      target="_blank"
    >
      <span>Directions</span>
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-arrow-right"></use>
      </svg>
    </a>
  </div>`;
    }
    #generateIngredientsMarkup() {
        return this.data.ingredients.map((ingredient)=>` <li class="recipe__ingredient">
  <svg class="recipe__icon">
    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($37426a2cd19eef49$exports))}#icon-check"></use>
  </svg>
  <div class="recipe__quantity">${ingredient.quantity || ""}</div>
  <div class="recipe__description">
    <span class="recipe__unit">${ingredient.unit}</span>
    ${ingredient.description}
    </div>
    </li>
  `).join("");
    }
}
var $d14dc0f178617192$export$2e2bcd8739ae039 = new $d14dc0f178617192$var$RecipeView(document.querySelector(".recipe"), "Recipe Not Found  \uD83C\uDF74\uD83D\uDE48", "Recipe Found \uD83D\uDE0B");



class $e3a3f6f0893f424b$var$SearchResultsView extends (0, $bc12b31dab7d742c$export$2e2bcd8739ae039) {
    constructor(parentElement, errorMessage, successMessage){
        super(parentElement, errorMessage, successMessage);
    }
}
var $e3a3f6f0893f424b$export$2e2bcd8739ae039 = new $e3a3f6f0893f424b$var$SearchResultsView(document.querySelector(".results"), "No Recipes With This Query \uD83C\uDF74\uD83D\uDE48", "Recipes Found \uD83D\uDE0B");


class $813cf99795e9ec97$var$SearchView {
    #parentElement = document.querySelector(".search");
    getInputValue() {
        return this.#parentElement.querySelector(".search__field").value;
    }
    addSearchHandler(handler) {
        this.#parentElement.addEventListener("submit", (e)=>{
            e.preventDefault();
            handler();
        });
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();


"use strict";
const $f50bd1f2915ed0f2$var$controlRecipe = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderSpinner();
        await (0, $0f1d4402dffacf5b$export$a30a1473507660db)(id);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe);
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).update((0, $0f1d4402dffacf5b$export$2d05d93cb3b7f780)((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).search.pageNumber));
        if ((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).bookmarks.length > 0) (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).update((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).bookmarks);
    } catch (error) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderErrorMessage();
    }
};
const $f50bd1f2915ed0f2$var$controlSearch = async function() {
    try {
        const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).getInputValue();
        if (!query) return;
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).renderSpinner();
        await (0, $0f1d4402dffacf5b$export$8d57c561ecf3eee5)(query);
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$2d05d93cb3b7f780)());
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e));
    } catch (error) {
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).renderErrorMessage();
    }
};
const $f50bd1f2915ed0f2$var$controlPagination = function(page) {
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$2d05d93cb3b7f780)(page));
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e));
};
const $f50bd1f2915ed0f2$var$controlServingsChange = function(servingsNumber) {
    (0, $0f1d4402dffacf5b$export$72a4c7e3635cff29)(servingsNumber);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe);
};
const $f50bd1f2915ed0f2$var$controlBookmark = function() {
    if ((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe.bookmarked) (0, $0f1d4402dffacf5b$export$136048bcb9946c75)((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe._id);
    else (0, $0f1d4402dffacf5b$export$72009cc673d27d80)((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).bookmarks);
};
function $f50bd1f2915ed0f2$var$FormatRecipeUploadFormData(formData) {
    const recipeObject = {};
    const ingredients = [];
    formData.forEach(([key, value])=>{
        if (!key.startsWith("ingredient")) recipeObject[key] = value;
        if (key.startsWith("ingredient") && value.trim() !== "") {
            const ingredientArray = value.split(",");
            if (ingredientArray.length !== 3) throw Error("Wrong ingredient format.");
            ingredients.push({
                quantity: +ingredientArray[0] || null,
                unit: ingredientArray[1] || "",
                description: ingredientArray[2]
            });
        }
    });
    recipeObject.ingredients = ingredients;
    return recipeObject;
}
const $f50bd1f2915ed0f2$var$controlUploadRecipe = async function(...formData) {
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSpinner();
    try {
        const formattedRecipe = $f50bd1f2915ed0f2$var$FormatRecipeUploadFormData(formData);
        await (0, $0f1d4402dffacf5b$export$d660c2254e74960d)(formattedRecipe);
        history.pushState(null, null, `#${(0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe._id}`);
        (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).bookmarks);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).recipe);
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).update((0, $0f1d4402dffacf5b$export$2d05d93cb3b7f780)((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).search.pageNumber));
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSuccessMessage("Recipe Uploaded Successfully.\uD83D\uDE0B");
        await (0, $d3824bf2ef2465db$export$5c069c93d2b7493f)(1);
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).closeModal();
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e));
    } catch (error) {
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderErrorMessage(error);
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $0f1d4402dffacf5b$export$fd68aeccd5e8e1ce)();
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addRenderHandler($f50bd1f2915ed0f2$var$controlRecipe);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addServingsHandler($f50bd1f2915ed0f2$var$controlServingsChange);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addBookmarkHandler($f50bd1f2915ed0f2$var$controlBookmark);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).addSearchHandler($f50bd1f2915ed0f2$var$controlSearch);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addpaginationhandler($f50bd1f2915ed0f2$var$controlPagination);
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).addUploadRecipeHandler($f50bd1f2915ed0f2$var$controlUploadRecipe);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render((0, $0f1d4402dffacf5b$export$ca000e230c0caa3e).bookmarks);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.57fab002.js.map
